const header = document.querySelector('.header');

if (header) {
    const menuToggle = header.querySelector('.header__menu-toggle');
    const mobileMenu = header.querySelector('.header__mobile-menu');
    const mobileMenuContent = mobileMenu ? mobileMenu.querySelector('.header__mobile-menu-content') : null;
    const mobileOverlayShell = header.querySelector('.header__mobile-overlay-shell');
    const mobileFooter = mobileOverlayShell ? mobileOverlayShell.querySelector('.header__mobile-overlay-footer') : null;
    let mobileFooterTrigger = null;

    const toggleHeaderShadow = () => {
        header.classList.toggle('is-scrolled', window.scrollY > 0);
    };

    const createMobileLink = (sourceLink) => {
        const link = document.createElement('a');
        link.href = sourceLink.getAttribute('href') || '#';
        link.textContent = sourceLink.textContent.trim();
        link.className = 'header__mobile-menu-link';

        if (sourceLink.classList.contains('is-active')) {
            link.classList.add('is-active');
        }

        return link;
    };

    const createMobileNavSection = (sourceSelector, label) => {
        const source = header.querySelector(sourceSelector);

        if (!source) {
            return null;
        }

        const links = Array.from(source.querySelectorAll('a'));

        if (links.length === 0) {
            return null;
        }

        const section = document.createElement('nav');
        section.className = 'header__mobile-menu-section';
        section.setAttribute('aria-label', label);
        links.forEach((link) => section.appendChild(createMobileLink(link)));

        return section;
    };

    const renderMobileMenu = () => {
        if (!mobileMenuContent) {
            return;
        }

        const audienceSection = createMobileNavSection('.header__audience-nav', 'Hedef kitle navigasyonu');
        const subnavSection = createMobileNavSection('.header__subnav-inner', 'mobil navigasyon');

        mobileMenuContent.replaceChildren(...[audienceSection, subnavSection].filter(Boolean));
    };

    const renderMobileFooter = () => {
        if (!mobileFooter) {
            return;
        }

        const footerSource = header.querySelector('.header__top-nav .has-dropdown');
        const triggerSource = footerSource ? footerSource.querySelector('.nav__trigger') : null;
        const dropdownLinks = footerSource ? Array.from(footerSource.querySelectorAll('.nav-dropdown__link')) : [];

        if (!triggerSource || dropdownLinks.length === 0) {
            mobileFooter.replaceChildren();
            return;
        }

        const trigger = document.createElement('button');
        trigger.className = 'header__mobile-footer-trigger';
        trigger.type = 'button';
        trigger.setAttribute('aria-expanded', 'false');
        trigger.textContent = triggerSource.textContent.trim();

        const dropdown = document.createElement('div');
        dropdown.className = 'header__mobile-footer-dropdown';
        dropdownLinks.forEach((sourceLink) => {
            const link = document.createElement('a');
            link.href = sourceLink.getAttribute('href') || '#';
            link.textContent = sourceLink.textContent.trim();
            dropdown.appendChild(link);
        });

        mobileFooter.replaceChildren(trigger, dropdown);
        mobileFooterTrigger = trigger;
    };

    renderMobileMenu();
    renderMobileFooter();

    const currentPage = window.location.pathname.split('/').pop() || 'index.html';
    const activeSubnavLink = header.querySelector(`.header__subnav-link[href="${currentPage}"], .header__mobile-menu-section[aria-label*="mobil navigasyon"] .header__mobile-menu-link[href="${currentPage}"]`);

    if (activeSubnavLink) {
        header.querySelectorAll('.header__subnav-link.is-active, .header__mobile-menu-section[aria-label*="mobil navigasyon"] .header__mobile-menu-link.is-active').forEach((link) => {
            link.classList.remove('is-active');
        });
        header.querySelectorAll(`.header__subnav-link[href="${currentPage}"], .header__mobile-menu-section[aria-label*="mobil navigasyon"] .header__mobile-menu-link[href="${currentPage}"]`).forEach((link) => {
            link.classList.add('is-active');
        });
    }

    const closeMobileFooter = () => {
        if (!mobileFooter || !mobileFooterTrigger) {
            return;
        }

        mobileFooter.classList.remove('is-open');
        mobileFooterTrigger.setAttribute('aria-expanded', 'false');
    };

    const closeMobileMenu = () => {
        header.classList.remove('is-mobile-menu-open');
        header.classList.remove('is-mobile-overlay-open');
        closeMobileFooter();

        if (mobileMenu) {
            mobileMenu.setAttribute('aria-hidden', 'true');
        }

        if (mobileOverlayShell) {
            mobileOverlayShell.setAttribute('aria-hidden', 'true');
        }

        if (menuToggle) {
            menuToggle.setAttribute('aria-expanded', 'false');
            menuToggle.setAttribute('aria-label', 'Menüyü aç');
        }

        document.body.classList.remove('is-header-overlay-open');
    };

    const openMobileMenu = () => {
        document.dispatchEvent(new CustomEvent('header:close-search'));
        header.classList.add('is-mobile-menu-open');
        header.classList.add('is-mobile-overlay-open');
        document.body.classList.add('is-header-overlay-open');

        if (mobileMenu) {
            mobileMenu.setAttribute('aria-hidden', 'false');
        }

        if (mobileOverlayShell) {
            mobileOverlayShell.setAttribute('aria-hidden', 'false');
        }

        if (menuToggle) {
            menuToggle.setAttribute('aria-expanded', 'true');
            menuToggle.setAttribute('aria-label', 'Menüyü kapat');
        }
    };

    const closeMobileOverlay = () => {
        document.dispatchEvent(new CustomEvent('header:close-search'));
        closeMobileMenu();
    };

    if (menuToggle && mobileMenu) {
        menuToggle.addEventListener('click', () => {
            if (header.classList.contains('is-mobile-overlay-open')) {
                closeMobileOverlay();
                return;
            }

            openMobileMenu();
        });
    }

    if (mobileFooter && mobileFooterTrigger) {
        mobileFooterTrigger.addEventListener('click', () => {
            const isOpen = mobileFooter.classList.toggle('is-open');
            mobileFooterTrigger.setAttribute('aria-expanded', String(isOpen));
        });
    }

    document.addEventListener('header:close-mobile-menu', closeMobileMenu);

    document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
            closeMobileOverlay();
        }
    });

    toggleHeaderShadow();
    window.addEventListener('scroll', toggleHeaderShadow, { passive: true });
}
